// Device identification from browser hints (userAgentData where available,
// UA-string parsing otherwise). Same API shape as before: a human-readable
// name plus a descriptor object.

function detectPlatform() {
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
    return "ios";
  }
  if (/Android/i.test(ua)) return "android";
  return "web";
}

function detectOs() {
  const uaData = navigator.userAgentData;
  if (uaData?.platform) return uaData.platform;
  const ua = navigator.userAgent || "";
  if (/Windows/i.test(ua)) return "Windows";
  if (/Android/i.test(ua)) return "Android";
  if (/iPad|iPhone|iPod/.test(ua)) return "iOS";
  if (/Mac OS X|Macintosh/i.test(ua)) return "macOS";
  if (/Linux/i.test(ua)) return "Linux";
  return "Unknown";
}

function detectModel() {
  const ua = navigator.userAgent || "";
  if (/iPhone/.test(ua)) return "iPhone";
  if (/iPad/.test(ua)) return "iPad";
  const android = ua.match(/Android [\d.]+; ([^;)]+)/);
  if (android) return android[1].replace(/ Build\/.*/, "").trim();
  return "";
}

function detectBrowser() {
  const brands = navigator.userAgentData?.brands;
  if (brands?.length) {
    const real = brands.find((b) => !/Not.?A.?Brand/i.test(b.brand));
    if (real) return real.brand;
  }
  const ua = navigator.userAgent || "";
  if (/Edg\//.test(ua)) return "Edge";
  if (/OPR\//.test(ua)) return "Opera";
  if (/Chrome\//.test(ua)) return "Chrome";
  if (/Firefox\//.test(ua)) return "Firefox";
  if (/Safari\//.test(ua)) return "Safari";
  return "Browser";
}

const DEVICE_ID_KEY = "tide_device_id";

const DeviceManager = {
  /**
   * Human-readable device name, e.g. "iPhone", "Pixel 8", "Chrome on Windows".
   */
  async getDeviceName() {
    const model = detectModel();
    if (model) return model;
    return `${detectBrowser()} on ${detectOs()}`;
  },

  /**
   * Complete device descriptor object.
   */
  async getDeviceDescriptor(includeIdentifier = false) {
    try {
      const descriptor = {
        name: await this.getDeviceName(),
        platform: detectPlatform(),
        osVersion: detectOs(),
        model: detectModel() || detectBrowser(),
        manufacturer: "",
      };

      if (includeIdentifier) {
        // Stable per-install identifier (random, persisted locally).
        try {
          let id = localStorage.getItem(DEVICE_ID_KEY);
          if (!id) {
            id = crypto.randomUUID();
            localStorage.setItem(DEVICE_ID_KEY, id);
          }
          descriptor.identifier = id;
        } catch {
          descriptor.identifier = null;
        }
      }

      return descriptor;
    } catch (error) {
      console.error("Failed to get device descriptor:", error);
      return { name: "Unknown Device", platform: detectPlatform() };
    }
  },
};

export { DeviceManager };
